import { Injectable } from '@angular/core';
import { EdlCfBuilderItemFormGroup, EdlCfBuilderItemPartial, EdlCfGenericModel, IEdlCfBuilderGenericService, MAX_TITLE_LENGTH } from '@edl-development/edl-custom-forms';
import { PaetepCfContextInfoModel } from '../../../item-models/paetep-cf-context-info.model';
import { PaetepCfBuilderContextInfoForm } from '../../forms/paetep-cf-builder-context-info/paetep-cf-builder-context-info-form.interface';
import { PaetepCfBuilderContextInfoPartial } from '../../forms/paetep-cf-builder-context-info/paetep-cf-builder-context-info-partial.interface';
import { FormBuilder, Validators } from '@angular/forms';
import { ContextInfoCustomFormType } from 'src/app/model/enum/observations/custom-forms/custom-form-context-info-type.enum';
import { CommonValidators } from '@edl-development/edl-common';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfBuilderContextInfoService implements IEdlCfBuilderGenericService<PaetepCfContextInfoModel, PaetepCfBuilderContextInfoForm, PaetepCfBuilderContextInfoPartial> {
    constructor(private formBuilder: FormBuilder) {}

    public buildForm = ({
        model, 
        buildChildForm
    } : {
        model?: PaetepCfContextInfoModel, 
        buildChildForm: (model: EdlCfGenericModel<any>) => EdlCfBuilderItemFormGroup<any>
    }): PaetepCfBuilderContextInfoForm => {
        return this.formBuilder.nonNullable.group({
            title: [model?.title ?? '', [Validators.required, CommonValidators.emptyString(), Validators.maxLength(MAX_TITLE_LENGTH)]],
            contextType: [model?.contextType ?? ContextInfoCustomFormType.BUILDING, [Validators.required]]
        });
    }

    public buildModel = (
        form: PaetepCfBuilderContextInfoPartial, 
        buildChildModel: (model: EdlCfBuilderItemPartial<any>) => EdlCfGenericModel<any>
    ): PaetepCfContextInfoModel => {
        return {
            title: form.title ?? '',
            contextType: form.contextType ?? ContextInfoCustomFormType.BUILDING
        };
    }
}
